export enum PriceChoice {
    GLOBAL_YIELD = 'global-yield',
    PRODUCT_YIELD = 'product-yield',
    PRODUCT_PRICE = 'product-price',
    PRODUCT_PRICE_WITH_VAT = 'product-price-with-vat'
}
